import { useState } from 'react';

const useContactModal = () => {
  // Hook agora não faz nada, pois não há mais modal de contato
  return {
    isModalOpen: false,
    openModal: () => {},
    closeModal: () => {},
    handleContactSubmit: () => {}
  };
};

export default useContactModal; 